

import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/List.vue';

import ConclusionsModule from '@/store/conclusions';

@Component({
    components: {
        Layout,
        ListBlock,
    }
})
export default class ConclusionsPage extends Vue {
    repository = ConclusionsModule;
}
